import React from 'react';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';

// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
export const WorkStatsContainer = ({ children }) => (
  <div className="wp-workCard_item wp-workCard--stats">{children}</div>
);

export const WorkStats = ({
  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'views' implicitly has an 'any' ty... Remove this comment to see the full error message
  views,
  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'sectionTitle' implicitly has an '... Remove this comment to see the full error message
  sectionTitle,
  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'recentlyRead' implicitly has an '... Remove this comment to see the full error message
  recentlyRead,
  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'certified' implicitly has an 'any... Remove this comment to see the full error message
  certified,
  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'wellKnownAuthor' implicitly has a... Remove this comment to see the full error message
  wellKnownAuthor,
  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
  children,
}) => (
  <WorkStatsContainer>
    {sectionTitle && <span>{sectionTitle}</span>}
    {views && views >= 1 && <span>{pluralize('View', views, true)}</span>}
    {recentlyRead && recentlyRead >= 1 && (
      <span>{pluralize('person', recentlyRead, true)} recently read</span>
    )}
    {certified && certified >= 1 && (
      <span>{pluralize('recommendation', certified, true)}</span>
    )}
    {wellKnownAuthor && <span>A highly followed author</span>}
    {children}
  </WorkStatsContainer>
);
WorkStats.propTypes = {
  views: PropTypes.number,
  recentlyRead: PropTypes.number,
  wellKnownAuthor: PropTypes.bool,
};
